import React, {useEffect, useState} from "react";
import {accountService} from "api";
import {Row, Col, Spin, Button} from "antd";
import useFetch from "hooks/useFetch";
const useFetchComponent = () => {
  const {data, loading, error} = useFetch(accountService.getRoleApi, 1);

  return (
    <div className="call-api">
      <div className="container">
        <div className="title" style={{fontWeight: "bold"}}>
          useFetch
        </div>
        <div className="title" style={{fontWeight: "bold"}}>
          RESPONSE
        </div>

        {loading && <Spin tip="Đang tải" size="large"></Spin>}
        {!loading && data && (
          <>
            <div>
              ID: <span>{data.id}</span>
            </div>
            <div>
              API: <span>{data.api}</span>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
export default useFetchComponent;
